import { useEffect, useRef } from 'react';

export default function BrandStatement() {
  const itemsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.2 }
    );
    itemsRef.current.forEach((el) => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="section-brand"
      data-section="Brand Statement"
      className="relative w-full py-20 md:py-44 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #0A0A0A 0%, #0f0f0f 50%, #0A0A0A 100%)', borderTop: '1px solid rgba(255,255,255,0.06)' }}
    >
      {/* Background watermark */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
        aria-hidden="true"
      >
        <span
          className="font-display font-black uppercase text-white"
          style={{
            fontSize: 'clamp(80px, 17vw, 230px)',
            opacity: 0.022,
            letterSpacing: '0.04em',
            whiteSpace: 'nowrap',
          }}
        >
          URBAN
        </span>
      </div>

      <div className="relative z-10 w-full px-8 md:px-16">
        <div className="max-w-4xl mx-auto text-center">

          {/* Label */}
          <div
            ref={(el) => { itemsRef.current[0] = el; }}
            className="reveal flex items-center justify-center gap-4 mb-10 md:mb-16"
          >
            <div className="w-10 h-px bg-white/20" />
            <span className="font-display text-[9px] tracking-[0.5em] uppercase text-white/35">
              A STATEMENT FOR THE BOLD
            </span>
            <div className="w-10 h-px bg-white/20" />
          </div>

          {/* Line 1 */}
          <div
            ref={(el) => { itemsRef.current[1] = el; }}
            className="reveal reveal-delay-1"
          >
            <p
              className="font-display font-semibold text-white leading-tight"
              style={{ fontSize: 'clamp(24px, 3.8vw, 46px)' }}
            >
              Jewelry shaped by the city —<br />
              <span className="text-white/50">its edge, its silence, its power.</span>
            </p>
          </div>

          {/* Thin divider */}
          <div
            ref={(el) => { itemsRef.current[2] = el; }}
            className="reveal reveal-delay-2 flex justify-center my-8 md:my-12"
          >
            <div
              className="h-px w-20"
              style={{ background: 'linear-gradient(90deg, transparent, #C0C0C0, #D4AF37, transparent)' }}
            />
          </div>

          {/* Line 2 */}
          <div
            ref={(el) => { itemsRef.current[3] = el; }}
            className="reveal reveal-delay-3"
          >
            <p
              className="font-display font-medium text-white/70 leading-tight"
              style={{ fontSize: 'clamp(20px, 3vw, 36px)' }}
            >
              Designed for those who don&apos;t follow trends.
            </p>
            <p
              className="font-display font-black uppercase leading-tight mt-4 chrome-text"
              style={{ fontSize: 'clamp(28px, 4.5vw, 58px)', letterSpacing: '-0.02em' }}
            >
              They define them.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
